
import { computed, defineComponent, PropType, reactive, toRefs } from 'vue'

export interface TabItemType {
  name: string
  content: string
  // FIXME: 개발시 추가 및 변경요망
}

export enum TabType {
  CENTER = 'center',
  HORIZONTAL_SCROLL = 'horizontal_scroll',
}

export default defineComponent({
  props: {
    modelValue: {
      type: [String, Number],
      require: true,
    },
    style: Object,
    items: {
      type: Array as PropType<Array<TabItemType>>,
      default: () => [],
    },
    selectedIndex: {
      type: Number,
      default: 0,
    },
    type: {
      type: String as PropType<TabType>,
      require: true,
    },
  },
  setup(props, { emit }) {
    const tabState = reactive({
      selectedIndex: props.selectedIndex,
      classes: computed(() => ({
        Tabs: true,
        'Tabs__title--center': props.type === TabType.CENTER,
        'Tabs__title--horizontal-scroll': props.type === TabType.HORIZONTAL_SCROLL,
      })),
      style: computed(() => ({ width: `${window.innerWidth - 24 * 2}px` })),
    })

    function tabClick(index: number) {
      tabState.selectedIndex = index
      emit('update:modelValue', index)
    }
    return {
      tabClick,
      ...toRefs(tabState),
      TabType,
    }
  },
})
